import type { SlideImage } from "yet-another-react-lightbox";

export function Gallery2013(){


const slides: SlideImage[] = [
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2013/IMG_001.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2013/SML_001.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2013/IMG_002.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2013/SML_002.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2013/IMG_003.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2013/SML_003.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2013/IMG_004.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2013/SML_004.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2013/IMG_005.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2013/SML_005.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2013/IMG_006.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2013/SML_006.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2013/IMG_007.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2013/SML_007.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2013/IMG_008.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2013/SML_008.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2013/IMG_009.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2013/SML_009.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2013/IMG_010.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2013/SML_010.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2013/IMG_011.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2013/SML_011.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2013/IMG_012.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2013/SML_012.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2013/IMG_013.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2013/SML_013.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2013/IMG_014.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2013/SML_014.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2013/IMG_015.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2013/SML_015.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2013/IMG_016.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2013/SML_016.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2013/IMG_017.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2013/SML_017.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2013/IMG_018.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2013/SML_018.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2013/IMG_019.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2013/SML_019.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2013/IMG_020.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2013/SML_020.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2013/IMG_021.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2013/SML_021.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2013/IMG_022.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2013/SML_022.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2013/IMG_023.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2013/SML_023.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2013/IMG_024.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2013/SML_024.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2013/IMG_025.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2013/SML_025.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2013/IMG_026.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2013/SML_026.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2013/IMG_027.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2013/SML_027.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2013/IMG_028.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2013/SML_028.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2013/IMG_029.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2013/SML_029.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2013/IMG_030.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2013/SML_030.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2013/IMG_031.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2013/SML_031.jpg"
        },
        {
          "src":  "https://jamhaw.com/images/gallery/Gallery2013/IMG_032.jpg",
          "alt":  "https://jamhaw.com/images/gallery/Gallery2013/SML_032.jpg"
        }
     ];

     return slides;
} 
